import { AsyncPipe, CommonModule, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { SvgComponent } from '@app/base-components';
import { I18nModule, TranslatePipe } from 'haba-core';
import { FocusDirective, SkipLink, SkipLinkService } from 'haba-storefrontlib';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-skip-link',
  templateUrl: './skip-link.component.html',
  styleUrls: ['./skip-link.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    NgFor,
    AsyncPipe,
    FocusDirective,
    TranslatePipe,
    I18nModule,
    SvgComponent,
  ],
})
export class SkipLinkComponent {
  skipLinks$: Observable<SkipLink[]> = this.skipLinkService.getSkipLinks();

  constructor(private skipLinkService: SkipLinkService) {}

  scrollToTarget(skipLink: SkipLink): void {
    this.skipLinkService.scrollToTarget(skipLink);
  }
}
